export default function findCompanionAdSlots() {
    return (googletag
        ?.pubads()
        ?.getSlots()
        ?.filter(slot => slot
        .getServices()
        .some(service => service.getName() === 'companion_ads')));
}
